import React, { useState } from 'react';
import './Tabs.css';

interface Tab {
  label: string;
  content: React.ReactNode;
}

interface TabsProps {
  tabs: Tab[];
}

export default function Tabs({ tabs }: TabsProps) {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleKeyDown = (event: React.KeyboardEvent, index: number) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    const direction = event.key === 'ArrowRight' ? 1 : -1;
    const nextIndex = (index + direction + tabs.length) % tabs.length;
    setActiveIndex(nextIndex);
    document.getElementById(`app-tab-${nextIndex}`)?.focus();
  };

  return (
    <div className="tabs-container">
      <div className="tabs-sidebar" role="tablist" aria-orientation="vertical">
        {tabs.map((tab, idx) => (
          <button
            key={tab.label}
            id={`app-tab-${idx}`}
            role="tab"
            aria-selected={activeIndex === idx}
            aria-controls="app-tab-panel"
            tabIndex={activeIndex === idx ? 0 : -1}
            className={`tab-btn${activeIndex === idx ? ' active' : ''}`}
            onClick={() => setActiveIndex(idx)}
            onKeyDown={(event) => handleKeyDown(event, idx)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div id="app-tab-panel" className="tabs-content" role="tabpanel" aria-labelledby={`app-tab-${activeIndex}`}>
        {tabs[activeIndex].content}
      </div>
    </div>
  );
}
